module.exports = __webpack_public_path__ + "img/php.f38aac80.svg";